'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var style = {
  fontSize: '11px',
  display: 'block',
  padding: '4px'
};
var styleLabel = {
  display: 'block',
  color: '#666'
};

exports['default'] = _createReactClass2['default']({

  displayName: 'Demo.Controls.Group',

  propTypes: {
    name: _propTypes2['default'].string.isRequired,
    children: _propTypes2['default'].node.isRequired
  },

  render: function render() {
    var _props = this.props;
    var name = _props.name;
    var children = _props.children;

    return _react2['default'].createElement(
      'label',
      { style: style, className: 'react-demo__control-group' },
      _react2['default'].createElement(
        'span',
        { style: styleLabel, className: 'react-demo__control-group-label' },
        name
      ),
      children
    );
  }

});
module.exports = exports['default'];